import React from "react";
import { TextInputField }  from "../../../helpers";
import Tooltip from "../../../helpers/Tooltip";

import { calculateBuyerQuotation, getFullName, round } from "../../../utils";
import _ from "lodash";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { useDispatch } from "react-redux";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

const urdOptions = [
    {label: "Yes", value: "Yes"},
    {label: "No", value: "No"}
]

const gstOptions = [
    {label: '0', value: 0},
    {label: '3', value: 3},
    {label: '5', value: 5},
    {label: '12', value: 12},
    {label: '18', value: 18},
    {label: '28', value: 28}
]

const SellerReqItem = (props) => {
    const { buyerQuote, buyerQuoteItem, buyerQuoteItems, sellersData, sellerReqs, allSellerDetails, displayLabel, setBuyerQuoteItems, setBuyerQuote, HSNMasterData, handleGSTRateOptions } = props

    const dispatch = useDispatch()

    const sellerDetails = sellersData.find(eachSeller =>  eachSeller.sellerReqItemId === buyerQuoteItem.sellerReqItemId)
    const sellerReqDetails = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === sellerDetails.sellerReqId)
    const userDetials = allSellerDetails.find(eachSeller => eachSeller.userId === sellerReqDetails.userId)
    const sellerCompanyName = userDetials?.companyName
    const sellerName = getFullName(userDetials?.firstName, userDetials?.lastName)

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)

    const handleBuyerQuoteItemOnChange = (event) => {
        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if(eachBuyerQuoteItem.buyerQuoteItemId === buyerQuoteItem.buyerQuoteItemId){
                eachBuyerQuoteItem[event.target.name] = event.target.value
            }
            // console.log("eachBuyerQuoteItem", eachBuyerQuoteItem)
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleSellerQtyChange = (event) => {
        if(parseFloat(event.target.value) > buyerQuoteItem.sellerQuoteQty){
            return dispatch(raiseToast({severity:'error', detail:`Only ${buyerQuoteItem.sellerQuoteQty} quantity available`, life: 3000}))
        }
        let updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if(eachBuyerQuoteItem.buyerQuoteItemId === buyerQuoteItem.buyerQuoteItemId){
                eachBuyerQuoteItem[event.target.name] = event.target.value === "" ? null : event.target.value
            }
            return eachBuyerQuoteItem
        })

        const relatedBuyerQuoteItems = updatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === buyerQuoteItem.buyerReqItemId)

        const totalSellerQuoteQty = _.sumBy(relatedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty) || 0) 
        const weightedSum = _.sumBy(relatedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bQuotSellerQty) || 0)
        const totalQuantity = _.sumBy(relatedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty) || 0)
        const weightedAverageSellerPrice = round(weightedSum / totalQuantity, 2)
        
        const buyerUnitPrice = buyerQuoteItem.bQuotUnitPrice

        const avgSellerPrice = weightedAverageSellerPrice
        const marginAmount = buyerUnitPrice - avgSellerPrice
        const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 2)

        updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if(eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId){
                eachBuyerQuoteItem.bQuotMarginRate = marginPercent
                eachBuyerQuoteItem.totReqQty = totalSellerQuoteQty
            }
            return eachBuyerQuoteItem
        })

        //if(!buyerQuote.isURP){
            updatedBuyerQuoteItems = handleGSTRateOptions(updatedBuyerQuoteItems, buyerQuoteItem.buyerReqItemId)
        //}

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        console.log("calculatedResult.buyerQuoteItems", calculatedResult.buyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    let beforeTax = ""
    let totalTax = ""
    let totalPrice = ""

    if(buyerQuoteItem.bQuotSellerQty){
        let bQuotSellerQuantity = round(buyerQuoteItem.bQuotSellerQty)
        beforeTax = round(bQuotSellerQuantity * buyerQuoteItem.bQuotSellerPrice)
        totalPrice = beforeTax
        totalTax = 0

        if(buyerQuoteItem.bQuotSellerGSTRate){
            totalTax = round(buyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
            totalPrice = totalTax + beforeTax
        }
    }

    let marginPercent = null
    if(buyerQuoteItem.bQuotUnitPrice){
        marginPercent = ((buyerQuoteItem.bQuotUnitPrice - buyerQuoteItem.bQuotSellerPrice) / buyerQuoteItem.bQuotUnitPrice) * 100
        marginPercent = round(marginPercent, 2) 
    }

    return(
        <div key={`buyerQuoteItem-${buyerQuoteItem.buyerQuoteItemId}`} className="grid align-items-center list-item-seller-row">
            <div className="flex col-12 lg:col-2 px-0 py-0 seller-company-name">
                <div className="col" style={{flexGrow: 1}}>
                    <p className={`m-0 ${buyerQuoteItem.isSellerReqExpired && "strike-through"}`} style={{fontSize: '12px'}}>
                        {sellerCompanyName} <span className="m-0 seller-name">({sellerName})</span>
                    </p>
                    <p className="m-0 text-sm seller-name" style={{fontSize: '12px'}}></p>
                </div>
            </div>
            <div className="flex col-12 lg:col-10">
                <div className="grid">
                    <div className="flex flex-row">
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-6rem choosen-qty">
                                <TextInputField name="bQuotSellerQty" value={buyerQuoteItem.bQuotSellerQty} onChange={handleSellerQtyChange} disabled={buyerQuoteItem.isSellerReqExpired} labelText={displayLabel && "Choosen Qty"} keyfilter="num" />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 seller-qty">
                                <TextInputField name="sellerQuoteQty" value={buyerQuoteItem.sellerQuoteQty} labelText={displayLabel && "Seller Qty"} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem delivery-period">
                                <TextInputField name="sellerLeadTime" tooltip={"Delivery period in days"} tooltipOptions={{showOnDisabled: true}} value={buyerQuoteItem.sellerLeadTime} onChange={handleBuyerQuoteItemOnChange} labelText={displayLabel && "D.Period"} disabled/>
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 seller-list-price">
                                {   displayLabel && 
                                    <label htmlFor="sellerListPrice" style={{fontSize:"12px", marginBottom:"3px"}}>
                                        S.L.Price
                                        <Tooltip target=".company-group-eye-icon" position="top" content="This is indicative price - for calculations, header list price is used" />
                                        <i className="pi pi-info-circle company-group-eye-icon ml-1"></i>
                                    </label>
                                }
                                <TextInputField name="bQuotSellerListPrice" id="sellerListPrice" value={buyerQuoteItem.bQuotSellerListPrice} className={buyerQuoteItem.bQuotSellerListPrice != buyerQuoteItem.bQuotListPrice && "strike-through"} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 seller-unit-price">
                                <TextInputField name="bQuotSellerPrice" value={buyerQuoteItem.bQuotSellerPrice} onChange={handleBuyerQuoteItemOnChange} labelText={displayLabel && "S.U.Price"} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem urd">
                                <TextInputField name="URD" value={sellerReqDetails.isURD ? "Yes": "No"} labelText={displayLabel && "URD"} disabled />
                            </div>
                            {
                                pmCompanyConfig.isHSNVisible ?
                                <div className="flex flex-column col-12 lg:col-1 pl-0 w-6rem seller-hsn">
                                    <TextInputField name="quotHSNCode" value={buyerQuoteItem.quotHSNCode} labelText={displayLabel && "S. HSN"} disabled />
                                </div>
                                :
                                null
                            }
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem">
                                <TextInputField name="bQuotSellerGSTRate" value={buyerQuoteItem.bQuotSellerGSTRate} labelText={displayLabel && (pmCompanyConfig.GSTRateLabel)} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 px-0 unit-logistics">
                                <TextInputField name="sellerUnitLogistics" value={buyerQuoteItem.sellerUnitLogistics} labelText={displayLabel && "Unit Logistics"} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pre-tax-amt">
                                <TextInputField name="beforeTax" value={beforeTax} labelText={displayLabel && "Pre Tax Amt"} disabled />  
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0">
                                <TextInputField name="totalPrice" value={totalPrice} labelText={displayLabel && "Total Amt."} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem">
                                <TextInputField name="bQuotSellerDiscountRate" value={buyerQuoteItem.bQuotSellerDiscountRate} labelText={displayLabel && "S.Disc %"} disabled />
                            </div>
                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem">
                                <TextInputField name="" value={totalPrice ? marginPercent : ""} labelText={displayLabel && "Margin %"} disabled />
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SellerReqItem